/**
 * Ephemeral (non-persisted) record of "which group page is currently
 * mounted", so the single global FloatingPostButton — rendered once by
 * Layout, outside any group's own component tree — knows to open the
 * composer pre-linked to that group instead of a normal ungrouped post.
 * Set by GroupPage on mount/update, cleared on unmount.
 */
import { create } from 'zustand'

export interface ActiveGroup {
  slug: string
  name: string
  canPostAsGroup: boolean
  // Closed groups implicitly restrict Action RSVP to members — the
  // composer needs this to decide whether to offer the visibility picker.
  isOpen: boolean
}

interface ActiveGroupState {
  activeGroup: ActiveGroup | null
  setActiveGroup: (group: ActiveGroup | null) => void
}

export const useActiveGroupStore = create<ActiveGroupState>()((set) => ({
  activeGroup: null,
  setActiveGroup: (group) => set({ activeGroup: group }),
}))
